import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerFarmIdAtom} from "./routerStore";
import {activeCompanyFieldsAtom} from "./activeCompanyFieldsStore";

export const activeFarmFieldsAtom = atomWithRefresh(async (get) => {
    const activeCompanyFields = await get(activeCompanyFieldsAtom);
    const activeFarmId = get(routerFarmIdAtom);

    return activeCompanyFields.fields.filter((field) => field.farmId === activeFarmId);
});

export const activeFarmFieldsLoadable = loadable(activeFarmFieldsAtom);
